// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {map} from 'lodash';

// Components
import MultiSelect from './multi-select';
import Select from './select';

function SelectWithMulti(props) {
    const {disabled, label, name, noMulti = false, options, placeholder, submitOnChange, validate} = props;

    const renderMultiSelect = () => (
        <MultiSelect
            disabled={disabled}
            label={label}
            multi={true}
            name={name}
            options={options}
            placeholder={placeholder}
            submitOnChange={submitOnChange}
            validate={validate}
        />
    );

    const renderSelect = () => (
        <Select {...{
                    noMulti: false,
                    ...props,
                }}
        >
            {placeholder ? <option value="">{placeholder}</option> : null}
            {map(options, ({value, label}) => (
                <option key={value} value={value}>
                    {label}
                </option>
            ))}
        </Select>
    );

    return !noMulti ? renderMultiSelect() : renderSelect();
}

SelectWithMulti.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    fetching: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    noMulti: PropTypes.bool,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    submitOnChange: PropTypes.bool,
    validate: PropTypes.array,
};

export default SelectWithMulti;
